import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import DialogTransition from 'src/components/DialogTransition';
import { ContractPaymentForm } from 'src/utils/constants/contracts';
import {
  formatBankAccountDetails,
  formatCreditCardDetails
} from 'src/utils/paymentMethodHelpers';
import useStyles from '../../../styles';

const PaymentMethodDetailsDialog = ({
  open,
  onClose,
  paymentForm,
  selectedBankAccount,
  selectedSecondaryBankAccount,
  selectedCard,
  clabe
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={DialogTransition}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className={classes.header}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography className={classes.header} color="primary" variant="h2">
          {t('CONTRACT_VIEW.CONTRACT_DETAIL.PAYMENT_METHOD_DETAILS')}
        </Typography>
      </DialogTitle>

      <DialogContent style={{ marginTop: 16 }}>
        {paymentForm === ContractPaymentForm.AUTOMATIC_DEBIT && selectedBankAccount && (
          <>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {t('CONTRACT_VIEW.CONTRACT_DETAIL.PRIMARY_BANK_ACCOUNT')}
              </Typography>
              <Typography variant="body1">
                {formatBankAccountDetails(selectedBankAccount)}
              </Typography>
            </Box>
            {selectedSecondaryBankAccount && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                  {t('CONTRACT_VIEW.CONTRACT_DETAIL.SECONDARY_BANK_ACCOUNT')}
                </Typography>
                <Typography variant="body1">
                  {formatBankAccountDetails(selectedSecondaryBankAccount)}
                </Typography>
              </Box>
            )}
          </>
        )}

        {paymentForm === ContractPaymentForm.CREDIT_CARD && selectedCard && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              {t('CONTRACT_VIEW.CONTRACT_DETAIL.CREDIT_CARD')}
            </Typography>
            <Typography variant="body1">
              {formatCreditCardDetails(selectedCard)}
            </Typography>
          </Box>
        )}

        {paymentForm === ContractPaymentForm.BANK_TRANSFER && clabe && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              {t('COMMON.CLABE')}
            </Typography>
            <Typography variant="body1">{clabe}</Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions style={{ padding: '16px 24px' }}>
        <Button onClick={onClose} color="primary">
          {t('COMMON.CLOSE')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PaymentMethodDetailsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  paymentForm: PropTypes.string,
  selectedBankAccount: PropTypes.object,
  selectedSecondaryBankAccount: PropTypes.object,
  selectedCard: PropTypes.object,
  clabe: PropTypes.string
};

PaymentMethodDetailsDialog.defaultProps = {
  paymentForm: null,
  selectedBankAccount: null,
  selectedSecondaryBankAccount: null,
  selectedCard: null,
  clabe: null
};

export default PaymentMethodDetailsDialog;